var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.showText')}},[_c('el-switch',{model:{value:(_vm.optionModel.showText),callback:function ($$v) {_vm.$set(_vm.optionModel, "showText", $$v)},expression:"optionModel.showText"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }